import { render, staticRenderFns } from "./params-detail.vue?vue&type=template&id=613f80f2&scoped=true&"
import script from "./params-detail.vue?vue&type=script&lang=ts&"
export * from "./params-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613f80f2",
  null
  
)

export default component.exports